import { escgpTestFirebaseConfig } from "./firebase/escpgtestfirebase";
import { firebaseconfiggestionale } from "./firebase/firebaseconfiggestionale";

/*Note: 
 This is full devapp <--- so where you test everything on dev environment.
*/

export const environment = {
    NAME: "development java",
    TEST_ROUTES: true,
    REPORT_ENV: false,
    MUTE_LOG: false,
    //this is 
    ML_USERS_SERVICE_URL: "https://devapi.eurovisionplayground.com",
    ML_DATA_SERVICE_URL: "https://ds.eurovisionplayground.com/v0/",
    ML_DATA_SERVICE_BASE_URL: "https://ds.eurovisionplayground.com/v0",
    FIREBASE_CONFIG: firebaseconfiggestionale
};
